import React from 'react'
import { Form, Button } from 'react-bootstrap'
import { PackagingTableView } from './PackagingTableView'

export const PackagingView = (props) => {
    return <div>
        <PackagingTableView
            packagings={props.storedPackaging}
        />
        <Form onSubmit={props.onSubmit}>
            <Form.Group>
                <Form.Label>Packaging type: </Form.Label>
                <select className="form-select" name="packagingType">
                    <option value='box'>Box</option>
                    <option value='polybag'>Polybag</option>
                    <option value='paddedEnvelope'>Padded Envelope</option>
                </select>
                <Form.Label>Brand: </Form.Label>
                <select className="form-select" name="brand">
                    <option value="Kite">Kite</option>
                </select>
                <Form.Label>Manufacturer's Code:</Form.Label>
                <Form.Control type="text" placeholder="KT340" name="manufacturerCode"></Form.Control>
                <Form.Label>Weight:</Form.Label>
                <Form.Control type="number" placeholder="100g" name="weight"></Form.Control>
                <Form.Label>Cost (£):</Form.Label>
                <Form.Control type="number" step="0.0001" placeholder="£0.34" name="cost"></Form.Control>
                <Form.Label>Size:</Form.Label>
                <Form.Control type="text" placeholder="9x9x9 inches" name="size"></Form.Control>
            </Form.Group>
            <Button type="submit">Submit</Button>
        </Form>

    </div>
}
